import { NavLink } from "react-router-dom";
import { MessageCircle, Radio, User } from "lucide-react";

const TABS = [
  { to: "/", label: "Chats", icon: MessageCircle, testId: "nav-chats" },
  { to: "/pulsos", label: "Pulsos", icon: Radio, testId: "nav-pulsos" },
  { to: "/perfil", label: "Perfil", icon: User, testId: "nav-perfil" },
];

export function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 q-glass border-t border-white/10"
      data-testid="bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="max-w-2xl mx-auto grid grid-cols-3">
        {TABS.map(({ to, label, icon: Icon, testId }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === "/"}
              data-testid={testId}
              className={({ isActive }) =>
                "flex flex-col items-center justify-center gap-1 py-3 text-[11px] font-display uppercase tracking-widest transition-colors " +
                (isActive ? "q-accent-text" : "text-slate-400 hover:text-slate-200")
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
                  <span>{label}</span>
                  {isActive && (
                    <span
                      className="h-[3px] w-8 rounded-full q-accent-bg"
                      style={{ boxShadow: "0 0 10px var(--accent-glow)" }}
                      aria-hidden="true"
                    />
                  )}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
